import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Langs from "../../app/lang/langs";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import styles from "./ClientsView.module.css"
import { useDispatch, useSelector } from "react-redux";
import { addEditClient } from "../../components/clients/clientsSlice";
import { getClients } from "../../components/clients/clientsSlice";
import { InputSwitch } from "primereact/inputswitch";

export default function EditClientModal(props) {

    const dispatch = useDispatch();

    const isMobile = useSelector((state) => state.settings.isMobile)

    const [inputStyle, setInputStyle] = useState(false)
    const [showDeletePopup, setShowDeletePopup] = useState(false)
    
    const [client, setClient] = useState(
        {
            id: null,
            nom: '',
            vfact: ''
        }
    )
    useEffect(() => {
        if (props.client) {
            setClient(props.client)
        } else {
            setClient(
                {
                    id: null,
                    nom: '',
                    vfact: ''
                }
            )
        }
    }, [props.client])

    const handleEditClient = (client) => {
        if (client && client.id && client.nom.trim() !== '') {
            dispatch(addEditClient({ id: client.id, name: client.nom, vfact: client.vfact }))
                .then((response) => {
                    const responseData = response.payload.responseData;
                    if (responseData && responseData.status == 1) {
                        dispatch(getClients())
                    }
                })
            handleClose()
        } else {
            setInputStyle(true)
        }
    }

    const handleDeleteClient = () => {
        if (client && client.id && client.nom.trim() !== '') {
            dispatch(addEditClient({ id: client.id, active: 0 }))
                .then((response) => {
                    const responseData = response.payload.responseData;
                    if (responseData && responseData.status == 1) {
                        dispatch(getClients())
                    }
                })
            handleClose()
        } else {
            setInputStyle(true)
        }
    }

    const handleClose = () => {
        setShowDeletePopup(false)
        props.setVisible(false)
        props.setClient(null)
        setInputStyle(false)
        setClient({
            id: null,
            nom: '',
            vfact: ''
        })
    }

    const deletePopup = () =>{
        return <Dialog
            visible={showDeletePopup}
            onHide={() => setShowDeletePopup(false) }
            style={{ width: isMobile === 1 ? "30%" : 'fit-content', maxHeight: isMobile === 2 ? "70vh" : "50vh", }}
            position="center"
            draggable={false}
            dismissableMask={false}
            width={'10rem'}
        >
            <Row style={{ maxHeight: isMobile === 2 ? "70vh" : "50vh", }}>
                <Col lg={12} xs={12} className="mt-4 d-flex justify-content-center text-center">
                    <h4><strong><Langs str={"DELETE_CLIENT_CONFIRM_MESSAGE"} /></strong></h4>
                </Col>
                <Col lg={12} xs={12} className="mt-5 d-flex justify-content-center">
                    <Col lg={3} >
                        <DynamicButton
                            onClick={() => handleDeleteClient()}
                            className=''
                            title={<Langs str="Delete" />}
                            active={true}
                            color="red"
                        />
                    </Col>
                </Col>
            </Row>
        </Dialog>
    }

    return (
        <Dialog
            visible={props.visible}
            style={{ width: isMobile === 1 ? "40%" : 'fit-content', maxHeight: isMobile === 2 ? "80vh" : "60vh", }}
            onHide={() => { if (!props.visible) return; handleClose() }}
            position="center"
            header={<Langs str='EDIT_CLIENT' />}
            draggable={false}
            dismissableMask={false}
            width={'10rem'}
        >
            <Row style={{ maxHeight: isMobile === 2 ? "80vh" : "60vh", }}>
                <Col lg={12} xs={12} className="mt-4">
                    <label><strong><Langs str={"Nom"} /></strong></label>
                </Col>
                <Col lg={12} xs={12} className="mt-2 d-flex justify-content-center">
                    <InputText invalid={inputStyle} className={styles.inputTextFull} value={client.nom} placeholder="Nom" onChange={(e) => setClient({ ...client, nom: e.target.value })} />
                </Col>
                <Col lg={12} xs={12} className="mt-4">
                    <label><strong><Langs str={"V-FACT"} /></strong></label>
                </Col>
                <Col lg={12} xs={12} className="mt-2 d-flex justify-content-center">
                    <InputText className={styles.inputTextFull} value={client.vfact} placeholder="V-FACT" onChange={(e) => setClient({ ...client, vfact: e.target.value })} />
                </Col>
                <Col lg={12} xs={12} className="mt-4 d-flex justify-content-between">
                    <Col lg={3} >
                        <DynamicButton
                            onClick={() => setShowDeletePopup(true)}
                            className=''
                            title={<Langs str="Delete" />}
                            active={true}
                            color="red"
                        />
                    </Col>
                    <Col lg={3} >
                        <DynamicButton
                            onClick={() => handleEditClient(client)}
                            className=''
                            title={<Langs str="EDIT" />}
                            active={true}
                            color="green"
                        />
                    </Col>
                </Col>
                {deletePopup()}
            </Row>
        </Dialog>
    )
}